<template>
    <div>

        <config-main-title>
            Envio Programado de Mensagem
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state
                :msg="'Nenhuma Programação Identificada.'"
                icon="fas fa-search"
                :action="'Incluir'"
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.st_titulo }}
                        </a>
                        <big data-toggle="tooltip" data-placement="top" title="Teto para data futura"
                            v-if="dado.dt_inicio_vigencia > $util.hoje()">
                            <i class="fas fa-plane-departure mr-2"></i>
                        </big>
                        <big data-toggle="tooltip" data-placement="top" title="Teto com vigência já passada"
                            v-if="dado.dt_final_vigencia < $util.hoje()">
                            <i class="fas fa-history mr-2"></i>
                        </big>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input"
                                :id="'ativo-' + id"
                                v-model="dado.fl_ativo"
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div class="d-flex" v-else-if="dado.js_params.tipo != 7">
                            <span data-toggle="tooltip" data-placement="top" title="Executar agora.">
                                <az-submit :color="dado.fl_manual ? 'success btn-sm' : 'primary btn-sm'" :hide_content_while_loading="true" 
                                    @click="executar_agora(dado)">
                                    <i class="fa fa-play" aria-hidden="true"></i>
                                </az-submit>
                            </span>
                            
                            <span v-if="$store.state.user.id_usuario == 1" data-toggle="tooltip" data-placement="top" title="Executar agora (Teste).">
                                <az-submit color="warning btn-sm ml-1" :hide_content_while_loading="true" 
                                    @click="executar_agora(dado, true)">
                                    <i class="fa-solid fa-clapperboard-play" aria-hidden="true"></i>
                                </az-submit>
                            </span>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Modal para envio manual da campanha -->
        <div class="modal fade" id="envioManualModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="envio_manual">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Enviar manualmente 
                            <span class="badge badge-secondary ml-2">
                                {{ envio_manual.st_titulo }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body" v-if="envio_manual">
                        <div class="form-row col col-12">
                            <az-periodo v-model="filtros" />
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="confirmar_envio_manual ()">Enviar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id ? '' : 'Nova' }}
                            Programação
                            <span class="badge badge-secondary ml-2" v-if="item && item.id">
                                #{{ item.id }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">

                        <div class="row">
                            <div class="col col-6">
                                <az-input
                                    placeholder="Informe o título da programação..."
                                    label="Título"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                            <div class="col col-6">
                                <az-input
                                    type="select"
                                    placeholder="Tipo..."
                                    label="Tipo"
                                    optionsDisplay="search"
                                    required
                                    :optionsList="[
                                        {id: '1', search: 'Confirmação de marcação'},
                                        {id: '2', search: 'Campanha por e-mail'},
                                        {id: '3', search: 'Integração com o ActiveCampaign'},
                                        {id: '4', search: 'Reembolso Check Status'},
                                        {id: '5', search: 'Mensagem por Whatsapp'},
                                        {id: '6', search: 'Importar Resultados de Laboratório'},
                                        {id: '7', search: 'Envio de faturas'},
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    v-model="item.js_params.tipo" />
                            </div>
                        </div>

                        <div class="row" v-if="item.js_params.tipo == '2' || item.js_params.tipo == '5'">
                            <div class="col col-6">
                            </div>
                            <div class="col col-6">
                                <az-input
                                    type="checkbox-group"
                                    label="Campanha manual"
                                    :validate="validate"
                                    v-model="item.fl_manual" />
                            </div>
                        </div>

                        <template v-if="!is_campanha_manual && item.js_params.tipo != '7'">
                            <az-sub-title class="mt-1" title="Periodicidade" />

                            <div class="row">
                                <div class="col col-12">
                                    <VueCronEditorBuefy
                                        locale="pt"
                                        cronSyntax='basic'
                                        :visibleTabs="['hourly', 'daily', 'weekly', 'monthly']"
                                        v-model="item.st_cron"
                                    />
                                </div>
                            </div>
                        </template>

                        <!-- TABS -->
                        <ul class="nav nav-tabs mt-1" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation" v-if="item.js_params.tipo != 3 && item.js_params.tipo != 4 && item.js_params.tipo != 6">
                                <a class="nav-link active" id="destinatarios-tab" data-toggle="tab" href="#destinatarios" role="tab" aria-controls="destinatarios" aria-selected="true">Destinatário(s)</a>
                            </li>
                            <li class="nav-item" role="presentation" v-if="item.js_params.tipo == 3">
                               <a class="nav-link active" id="activecampaign-tab" data-toggle="tab" href="#activecampaign" role="tab" aria-controls="activecampaign" aria-selected="false">Configurações do ActiveCampaign</a>
                            </li>
                            <li class="nav-item" role="presentation" v-if="item.js_params.tipo == 3">
                               <a class="nav-link" id="activecampaignlista-tab" data-toggle="tab" href="#activecampaignlista" role="tab" aria-controls="activecampaignlista" aria-selected="false">Lista de Contatos</a>
                            </li>
                            <li class="nav-item" role="presentation" v-if="item.js_params.tipo == 2 || item.js_params.tipo == 5 || item.js_params.tipo == 7">
                               <a class="nav-link" id="conteudo-tab" data-toggle="tab" href="#conteudo" role="tab" aria-controls="conteudo" aria-selected="false">
                                {{ item.js_params.tipo == 2 || item.js_params.tipo == 7 ? 'Conteúdo do e-mail' : 'Conteúdo da mensagem'}}
                                </a>
                            </li>
                            <li class="nav-item" role="presentation" v-if="item.js_params.tipo == 2 || item.js_params.tipo == 7">
                               <a class="nav-link" id="anexo-tab" data-toggle="tab" href="#anexo" role="tab" aria-controls="anexo" aria-selected="false">Anexar relatório</a>
                            </li>
                            <li class="nav-item" role="presentation" v-if="item.js_params.tipo == 4">
                               <a class="nav-link" id="reembolso-tab" data-toggle="tab" href="#reembolso" role="tab" aria-controls="anexo" aria-selected="false">Reembolso</a>
                            </li>
                            <li class="nav-item" role="runlogs" v-if="item.js_params.tipo == 6">
                               <a class="nav-link" id="resultados-tab" data-toggle="tab" href="#resultados" role="tab" aria-controls="resultados" aria-selected="false">Selecionar Terceiro(s)</a>
                            </li>
                            <li class="nav-item" role="runlogs" v-if="item.runlogs && item.runlogs.length">
                               <a class="nav-link" id="runlogs-tab" data-toggle="tab" href="#runlogs" role="tab" aria-controls="runlogs" aria-selected="false">Logs</a>
                            </li>
                        </ul>

                        <div class="tab-content container" id="myTabContent">

                            <!-- REEMBOLSO -->
                            <div class="tab-pane fade show active" v-if="item.js_params.tipo == 4" id="reembolso" role="tabpanel" aria-labelledby="reembolso-tab">

                                <div class="row mt-3">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            label="Verificar status a partir de..."
                                            type="number"
                                            placeholder="60..."
                                            v-model="item.js_params.dias_inicio">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon2">
                                                        dias
                                                    </span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                </div>

                            </div>

                            <!-- DESTINATÁRIOS -->
                            <div class="tab-pane fade show active" v-if="item.js_params.tipo != 3" id="destinatarios" role="tabpanel" aria-labelledby="destinatarios-tab">

                                <!-- Mensagem por whatsapp -->
                                <template v-if="item.js_params && item.js_params.tipo == 5">

                                    <div class="row">

                                        <div class="col col-6">
                                             <az-input
                                                type="select"
                                                placeholder="Tipo de Destinatário..."
                                                label="Tipo de destinatário"
                                                optionsDisplay="search"
                                                required
                                                :optionsList="[{id: '1', search: 'Relatório'}]"
                                                optionsData="id"
                                                :validate="validate"
                                                :edicao="false"
                                                v-model="item.js_params.whatsapp_tipo_destinatario" />
                                        </div>

                                        <div class="col col-6">
                                            <az-input
                                                placeholder="Selecionar relatório..."
                                                label="Relatório"
                                                type="select"
                                                required
                                                optionsMode="aql"
                                                service="campanhas.relatorios"
                                                optionsDisplay="title"
                                                optionsData="id"
                                                :validate="validate"
                                                v-model="item.js_params.whatsapp_destinatario_relatorio_id">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append" v-if="item.js_params.whatsapp_destinatario_relatorio_id">
                                                        <button type="button" class="btn btn-outline-primary" @click="abrir_relatorio(item.js_params.whatsapp_destinatario_relatorio_id)">
                                                            <i class="fa-regular fa-file-lines"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        
                                        <div class="col col-6">
                                        </div>

                                        <div class="col col-6" >
                                            <az-input
                                                placeholder="Selecione o e-mail..."
                                                label="Campo do relatório com o celular"
                                                type="select"
                                                optionsDisplay="name"
                                                optionsData="name"
                                                :optionsList="lista_campos_whatsapp_destinatario"
                                                required
                                                :validate="validate"
                                                v-model="item.js_params.whatsapp_destinatario_relatorio_campo"
                                            />
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="col col-6">
                                        </div>

                                        <div class="col col-6">
                                            <az-input
                                                placeholder="Selecione o período..."
                                                label="Parâmetro do relatório do tipo 'período'"
                                                type="select"
                                                optionsDisplay="title"
                                                optionsData="id"
                                                :optionsList="lista_parametros_whatsapp_destinatario"
                                                v-model="item.js_params.whatsapp_destinatario_relatorio_param"
                                            />
                                        </div>

                                    </div>

                                    <template v-if="item.js_params.whatsapp_destinatario_relatorio_id && item.js_params.whatsapp_destinatario_relatorio_param && !is_campanha_manual">

                                        <div class="row">

                                            <div class="col col-6">
                                            </div>

                                            <div class="col col-4">
                                                <az-input
                                                    placeholder="Filtro do periodo..."
                                                    :label="filtrar_periodo_label()"
                                                    type="number"
                                                    required
                                                    :validate="validate"
                                                    v-model="item.js_params.whatsapp_destinatario_relatorio_param_dias">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <div class="input-group-append">
                                                                <az-input 
                                                                    type="select"
                                                                    class="ml-1"
                                                                    :placeholder="Selecione"
                                                                    optionsDisplay="search"
                                                                    :optionsList="[
                                                                        { id: 'hours', search: 'Hora(s)' },
                                                                        { id: 'days', search: 'Dia(s)' },
                                                                        { id: 'days_ate', search: 'Dia(s) até Hoje' },
                                                                        { id: 'weeks', search: 'Semana(s)' },
                                                                        { id: 'weeks_ate', search: 'Semana(s) até Hoje' },
                                                                        { id: 'months', search: 'Mês(es)' }
                                                                    ]"
                                                                    optionsData="id"
                                                                    :validate="validate"
                                                                    v-model="item.js_params.tipo_antecedencia" />
                                                            </div>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>

                                            <div class="col col-2">
                                                <az-input
                                                    type="select"
                                                    placeholder="Selecione o tipo do filtro"
                                                    label="Tipo do filtro do período"
                                                    optionsDisplay="search"
                                                    required
                                                    :optionsList="[{id: '1', search: 'Anterior'}, {id: '2', search: 'Posterior'}]"
                                                    optionsData="id"
                                                    :validate="validate"
                                                    v-model="item.js_params.whatsapp_destinatario_relatorio_param_dias_ant" />
                                            </div>

                                        </div>

                                        <div class="row" v-if="item && item.js_params && item.js_params.tipo_antecedencia && item.js_params.tipo_antecedencia != 'hours'">
                                            <div class="col col-6 offset-md-6">
                                                <div class="alert alert-info mt-3">
                                                    <!-- Ex.: Hoje, buscar para data {{ $util.getFormatDate(
                                                            $util.getDataDias(item.js_params.whatsapp_destinatario_relatorio_param_dias 
                                                            * ( item.js_params.whatsapp_destinatario_relatorio_param_dias_ant == 1 ? -1 : 1 ))
                                                        ) }} -->
                                                    {{ exibir_periodo() }}
                                                </div>
                                            </div>
                                        </div>

                                    </template>

                                </template>

                                <!-- CONFIRMAR MARCAÇÃO -->
                                <template v-if="item.js_params && item.js_params.tipo == 1">

                                    <div class="row">

                                        <div class="col col-6">
                                             <az-input
                                                type="select"
                                                placeholder="Tipo de Destinatário..."
                                                label="Tipo de destinatário"
                                                optionsDisplay="search"
                                                required
                                                :optionsList="[{id: '1', search: 'Relatório'}]"
                                                optionsData="id"
                                                :validate="validate"
                                                :edicao="false"
                                                v-model="item.js_params.marcacao_tipo_destinatario" />
                                        </div>

                                        <div class="col col-6">
                                            <az-input
                                                placeholder="Selecionar relatório..."
                                                label="Relatório"
                                                type="select"
                                                required
                                                optionsMode="aql"
                                                service="campanhas.relatorios"
                                                optionsDisplay="title"
                                                optionsData="id"
                                                :validate="validate"
                                                v-model="item.js_params.marcacao_relatorio_id">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append" v-if="item.js_params.marcacao_relatorio_id">
                                                        <button type="button" class="btn btn-outline-primary" @click="abrir_relatorio(item.js_params.marcacao_relatorio_id)">
                                                            <i class="fa-regular fa-file-lines"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>

                                    </div>

                                    <div class="row" >

                                        <div class="col col-6">
                                        </div>

                                        <div class="col col-6" >
                                            <az-input
                                                placeholder="Selecione o id da marcacao..."
                                                label="Campo do relatório com o código da marcação"
                                                type="select"
                                                optionsDisplay="name"
                                                optionsData="name"
                                                :optionsList="lista_campos_marcacao"
                                                required
                                                :validate="validate"
                                                v-model="item.js_params.marcacao_relatorio_campo"
                                            />
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="col col-6">
                                        </div>

                                        <div class="col col-6">
                                            <az-input
                                                placeholder="Selecione o período..."
                                                label="Parâmetro do relatório do tipo 'período'"
                                                type="select"
                                                optionsDisplay="title"
                                                optionsData="id"
                                                required
                                                :validate="validate"
                                                :optionsList="lista_parametros_marcacao"
                                                v-model="item.js_params.marcacao_relatorio_param"
                                            />
                                        </div>

                                    </div>

                                    <div class="row">

                                        <div class="col col-6">
                                        </div>

                                        <div class="col col-6">
                                            <az-input
                                                placeholder="informe a antecedência..."
                                                label="Antencedência (em dias)"
                                                min="0"
                                                type="number"
                                                required
                                                :validate="validate"
                                                v-model="item.js_params.marcacao_relatorio_param_dias"
                                            />
                                        </div>

                                    </div>

                                </template>

                                <!-- E-mail -->
                                <template v-if="item.js_params && item.js_params.tipo == 2 || item.js_params.tipo == 7">

                                    <div class="row" v-if="item.js_params.tipo != 7">

                                        <div class="col col-6">
                                             <az-input
                                                type="select"
                                                placeholder="Tipo de Destinatário..."
                                                label="Tipo de destinatário"
                                                optionsDisplay="search"
                                                required
                                                :optionsList="[{id: '1', search: 'Relatório'}, {id: '2', search: 'E-mail'}]"
                                                optionsData="id"
                                                :validate="validate"
                                                v-model="item.js_params.email_tipo_destinatario" />
                                        </div>

                                        <div class="col col-6">
                                            <template v-if="item.js_params.email_tipo_destinatario == 1">
                                                <az-input
                                                    placeholder="Selecionar relatório..."
                                                    label="Relatório"
                                                    type="select"
                                                    required
                                                    optionsMode="aql"
                                                    service="campanhas.relatorios"
                                                    optionsDisplay="title"
                                                    optionsData="id"
                                                    :validate="validate"
                                                    v-model="item.js_params.email_destinatario_relatorio_id">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append" v-if="item.js_params.email_destinatario_relatorio_id">
                                                            <button type="button" class="btn btn-outline-primary" @click="abrir_relatorio(item.js_params.email_destinatario_relatorio_id)">
                                                                <i class="fa-regular fa-file-lines"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </template>
                                            <template v-if="item.js_params.email_tipo_destinatario == 2">
                                                <az-input
                                                    placeholder="E-mail do destinatário"
                                                    label="Informe o e-mail do destinatário"
                                                    type="text"
                                                    required
                                                    :validate="validate"
                                                    v-model="item.js_params.email_destinatario_emails"
                                                />
                                            </template>

                                        </div>

                                    </div>

                                    <template v-if="item.js_params.email_tipo_destinatario == 1 && item.js_params.tipo != 7">

                                        <div class="row" >

                                            <div class="col col-6">
                                            </div>

                                            <div class="col col-6" >
                                                <az-input
                                                    placeholder="Selecione o e-mail..."
                                                    label="Campo do relatório com o e-mail"
                                                    type="select"
                                                    optionsDisplay="name"
                                                    optionsData="name"
                                                    :optionsList="lista_campos_email_destinatario"
                                                    required
                                                    :validate="validate"
                                                    v-model="item.js_params.email_destinatario_relatorio_campo"
                                                />
                                            </div>

                                        </div>

                                        <div class="row">

                                            <div class="col col-6">
                                            </div>

                                            <div class="col col-6">
                                                <az-input
                                                    placeholder="Selecione o período..."
                                                    label="Parâmetro do relatório do tipo 'período'"
                                                    type="select"
                                                    optionsDisplay="title"
                                                    optionsData="id"
                                                    :optionsList="lista_parametros_email_destinatario"
                                                    v-model="item.js_params.email_destinatario_relatorio_param"
                                                />
                                            </div>

                                        </div>

                                        <div class="row" v-if="item.js_params.email_destinatario_relatorio_id && item.js_params.email_destinatario_relatorio_param && !is_campanha_manual">

                                            <div class="col col-6">
                                            </div>

                                            <div class="col col-4">
                                                <az-input
                                                    placeholder="Informe o filtro do periodo..."
                                                    :label="filtrar_periodo_label()"
                                                    type="number"
                                                    required
                                                    :validate="validate"
                                                    v-model="item.js_params.email_destinatario_relatorio_param_dias"
                                                >
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <div class="input-group-append">
                                                                <az-input 
                                                                    type="select"
                                                                    class="ml-1"
                                                                    :placeholder="Selecione"
                                                                    optionsDisplay="search"
                                                                    :optionsList="[
                                                                        { id: 'hours', search: 'Hora(s)' },
                                                                        { id: 'days', search: 'Dia(s)' },
                                                                        { id: 'days_ate', search: 'Dia(s) até Hoje' },
                                                                        { id: 'weeks', search: 'Semana(s)' },
                                                                        { id: 'weeks_ate', search: 'Semana(s) até Hoje' },
                                                                        { id: 'months', search: 'Mês(es)' }
                                                                    ]"
                                                                    optionsData="id"
                                                                    :validate="validate"
                                                                    v-model="item.js_params.tipo_antecedencia" />
                                                            </div>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>

                                            <div class="col col-2">
                                                <az-input
                                                    type="select"
                                                    placeholder="Selecione o tipo do filtro"
                                                    label="Tipo do filtro do período"
                                                    optionsDisplay="search"
                                                    required
                                                    :optionsList="[{id: '1', search: 'Anterior'}, {id: '2', search: 'Posterior'}]"
                                                    optionsData="id"
                                                    :validate="validate"
                                                    v-model="item.js_params.email_destinatario_relatorio_param_dias_ant"
                                                />
                                            </div>

                                        </div>

                                        <div class="row" v-if="item && item.js_params && item.js_params.tipo_antecedencia && item.js_params.tipo_antecedencia != 'hours'">
                                            <div class="col col-6 offset-md-6">
                                                <div class="alert alert-info mt-3">
                                                    <!-- Ex.: Hoje, buscar para data {{ $util.getFormatDate(
                                                            $util.getDataDias(item.js_params.whatsapp_destinatario_relatorio_param_dias 
                                                            * ( item.js_params.whatsapp_destinatario_relatorio_param_dias_ant == 1 ? -1 : 1 ))
                                                        ) }} -->
                                                    {{ exibir_periodo() }}
                                                </div>
                                            </div>
                                        </div>

                                    </template>

                                    <template v-if="item.js_params.tipo == 2 || item.js_params.tipo == 7">
                                        <div class="row" v-if="item.js_params.tipo != 7">
                                            <div class="col col-6"></div>
                                            <div class="col col-6">
                                                <hr />
                                            </div>
                                        </div>
                                        <div class="row"  v-if="item.js_params.tipo == 7">
                                            <div class="col col-6" v-if="item.js_params.tipo != 7"></div>
                                            <div class="col col-6">
                                                <az-input
                                                    placeholder="E-mail que consta no cadastro da Operadora"
                                                    :edicao="false"
                                                    label="E-mail do destinatário"
                                                />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col col-6" v-if="item.js_params.tipo != 7"></div>
                                            <div class="col col-6">
                                                <az-input
                                                    placeholder="CC"
                                                    label="Informe o(s) e-mail(s) para cópia (CC)"
                                                    v-model="item.js_params.email_destinatario_cc_param"
                                                />
                                            </div>
                                        </div>
                                        <div class="row" >
                                            <div class="col col-6" v-if="item.js_params.tipo != 7"></div>
                                            <div class="col col-6">
                                                <az-input
                                                    placeholder="BCC"
                                                    label="Informe o(s) e-mail(s) para cópia (BCC)"
                                                    v-model="item.js_params.email_destinatario_bcc_param"
                                                />
                                            </div>
                                        </div>
                                    </template>

                                </template>

                            </div>

                            <!-- ACTIVECAMPAIGN -->
                            <div class="tab-pane fade show active" v-if="item.js_params.tipo == 3" id="activecampaign" role="tabpanel" aria-labelledby="activecampaign-tab">

                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            placeholder="Ex: https://<conta no activecampaign>.api-us1.com/"
                                            label="Informe a URL base da API"
                                            required
                                            :validate="validate"
                                            v-model="item.js_params.activecampaign_urlbase" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            placeholder="Informe o token de authenticação do ActiveCampaign"
                                            label="Chave/Token de autenticação"
                                            required
                                            :validate="validate"
                                            v-model="item.js_params.activecampaign_appkey" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            placeholder="Nome da lista de contatos"
                                            label="Nome da lista de contatos"
                                            required
                                            :validate="validate"
                                            v-model="item.js_params.activecampaign_nome_lista" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            placeholder="Descrição do grupo de usuários no ActiveCampaign"
                                            label="Descrição do grupo de usuários no ActiveCampaign"
                                            required
                                            :validate="validate"
                                            v-model="item.js_params.activecampaign_descricao_grupo" />
                                    </div>
                                </div>

                            </div>

                            <!-- ACTIVECAMPAIGN LISTA-->
                            <div class="tab-pane fade show" v-if="item.js_params.tipo == 3" id="activecampaignlista" role="tabpanel" aria-labelledby="activecampaignlista-tab">
                                <div class="row">
                                    <div class="col col-6">
                                        <az-input
                                            placeholder="Selecionar relatório..."
                                            label="Relatório"
                                            type="select"
                                            optionsMode="aql"
                                            service="campanhas.relatorios"
                                            optionsDisplay="title"
                                            optionsData="id"
                                            required
                                            :validate="validate"
                                            v-model="item.js_params.activecampaign_relatorio_id"
                                        />
                                    </div>
                                </div>

                                <div class="row" v-if="item.js_params.activecampaign_relatorio_id">

                                    <div class="col col-6">
                                        <az-input
                                            placeholder="Selecione o período..."
                                            label="Parâmetro do relatório do tipo 'período'"
                                            type="select"
                                            optionsDisplay="title"
                                            optionsData="id"
                                            :optionsList="lista_parametros_activecampaign"
                                            v-model="item.js_params.activecampaign_relatorio_param"
                                        />
                                    </div>

                                </div>

                                <div class="row" v-if="item.js_params.activecampaign_relatorio_id && item.js_params.activecampaign_relatorio_param">

                                    <div class="col col-4">
                                        <az-input
                                            placeholder="Informe o filtro do periodo..."
                                            :label="filtrar_periodo_label()"
                                            type="number"
                                            required
                                            :validate="validate"
                                            v-model="item.js_params.activecampaign_relatorio_param_dias"
                                        >
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <div class="input-group-append">
                                                        <az-input 
                                                            type="select"
                                                            class="ml-1"
                                                            :placeholder="Selecione"
                                                            optionsDisplay="search"
                                                            :optionsList="[
                                                                { id: 'hours', search: 'Hora(s)' },
                                                                { id: 'days', search: 'Dia(s)' },
                                                                { id: 'days_ate', search: 'Dia(s) até Hoje' },
                                                                { id: 'weeks', search: 'Semana(s)' },
                                                                { id: 'weeks_ate', search: 'Semana(s) até Hoje' },
                                                                { id: 'months', search: 'Mês(es)' }
                                                            ]"
                                                            optionsData="id"
                                                            :validate="validate"
                                                            v-model="item.js_params.tipo_antecedencia" />
                                                    </div>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>

                                    <div class="col col-2">
                                        <az-input
                                            type="select"
                                            placeholder="Selecione o tipo do filtro"
                                            label="Tipo do filtro do período"
                                            optionsDisplay="search"
                                            required
                                            :optionsList="[{id: '1', search: 'Anterior'}, {id: '2', search: 'Posterior'}]"
                                            optionsData="id"
                                            :validate="validate"
                                            v-model="item.js_params.activecampaign_relatorio_param_dias_ant"
                                        />
                                    </div>

                                </div>

                                <div class="row" v-if="item && item.js_params && item.js_params.tipo_antecedencia && item.js_params.tipo_antecedencia != 'hours'">
                                    <div class="col col-6">
                                        <div class="alert alert-info mt-3">
                                            <!-- Ex.: Hoje, buscar para data {{ $util.getFormatDate(
                                                    $util.getDataDias(item.js_params.whatsapp_destinatario_relatorio_param_dias 
                                                    * ( item.js_params.whatsapp_destinatario_relatorio_param_dias_ant == 1 ? -1 : 1 ))
                                                ) }} -->
                                            {{ exibir_periodo() }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Logs -->
                            <div class="tab-pane fade show" v-if="item.runlogs && item.runlogs.length" id="runlogs" role="tabpanel" aria-labelledby="runlogs-tab">

                                <div class="alert alert-info mt-3"> 
                                    Logs dos últimos 7 dias
                                </div>

                                <table class="table small">
                                    <tbody>
                                        <tr v-for="(runlog, irx) in item.runlogs" :key="irx">
                                            <td>
                                                <i class="fa fa-check-circle text-success" aria-hidden="true" v-if="runlog.fl_sucesso"></i>
                                                <i class="fa fa-times-circle text-danger" aria-hidden="true" v-else></i>
                                            </td>
                                            <td>#{{ runlog.id_log_integracao }}</td>
                                            <td>
                                                <span v-if="runlog.created_at">
                                                    {{ $util.getFormatDate(runlog.created_at) }}
                                                    {{ runlog.created_at.slice(11,16) }}
                                                </span>
                                            </td>
                                            <td>{{ runlog.st_mensagem }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- CONTEUDO -->
                            <div class="tab-pane fade show" v-if="item.js_params.tipo == 2 || item.js_params.tipo == 5 || item.js_params.tipo == 7" id="conteudo" role="tabpanel" aria-labelledby="conteudo-tab">

                                <!-- Mensagem por whatsapp -->
                                <template v-if="item.js_params && item.js_params.tipo == 5">

                                    <div class="row">

                                            <div class="col col-12">

                                                <az-input
                                                    label="Conteúdo da mensagem"
                                                    type="textarea"
                                                    :rows="6"
                                                    required
                                                    :validate="validate"
                                                    v-model="item.js_params.whatsapp_body_conteudo"
                                                />

                                            </div>

                                    </div>

                                    <div class="row">

                                            <div class="col col-12">

                                                <az-input
                                                    placeholder="Selecione o id da marcacao..."
                                                    label="Tags disponíveis"
                                                    sizing="sm"
                                                    icon="fa fa-plus"
                                                    type="select"
                                                    optionsDisplay="name"
                                                    optionsData="name"
                                                    :optionsList="lista_campos_whatsapp_destinatario"
                                                    v-model="whatsapp_body_tag"
                                                    @input="incluir_novo_campo_whatsapp()"
                                                />

                                            </div>

                                    </div>

                                    <div class="row">

                                            <div class="col col-6" v-if="kualiz">

                                                <az-input
                                                    label="Id da imagem na galeria do Kualiz"
                                                    sizing="sm"
                                                    icon="fa fa-image"
                                                    v-model="item.js_params.whatsapp_imagem_id"
                                                />

                                            </div>

                                            <template v-else-if="escallo">

                                                <div class="col col-3" >

                                                    <az-input
                                                        placeholder="Selecione o nome do paciente..."
                                                        label="Campo com o nome do paciente"
                                                        type="select"
                                                        optionsDisplay="name"
                                                        optionsData="name"
                                                        :optionsList="lista_campos_whatsapp_destinatario"
                                                        required
                                                        :validate="validate"
                                                        v-model="item.js_params.escallo_nome_paciente"
                                                    />

                                                </div>

                                                <div class="col col-3" >

                                                    <az-input
                                                        placeholder="Selecione o ID do paciente..."
                                                        label="Campo com o ID do paciente"
                                                        type="select"
                                                        optionsDisplay="name"
                                                        optionsData="name"
                                                        :optionsList="lista_campos_whatsapp_destinatario"
                                                        required
                                                        :validate="validate"
                                                        v-model="item.js_params.escallo_id_paciente"
                                                    />

                                                </div>

                                            </template>

                                            <div class="col col-6">

                                                <az-input
                                                    label="Nome do Template"
                                                    sizing="sm"
                                                    v-model="item.js_params.whatsapp_nome_template"
                                                    v-if="kualiz || escallo || ingenium || eas"
                                                />

                                            </div>

                                    </div>

                                    <div class="row" v-if="kualiz">

                                        <div class="col col-6">
                                            
                                            <az-input
                                                label="Kualiz - Outra Configuração"
                                                placeholder="A mesma de outras configurações..."
                                                sizing="sm"
                                                icon="fa fa-gear"
                                                v-model="item.js_params.whatsapp_outra_config"
                                            />

                                        </div>

                                    </div>

                                </template>
                                
                                <!-- Email -->
                                <template v-else>

                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input
                                                placeholder="Informe o assunto do e-mail"
                                                label="Assunto do e-mail"
                                                optionsDisplay="search"
                                                required
                                                :validate="validate"
                                                v-model="item.js_params.email_assunto_conteudo" />
                                        </div>
                                    </div>

                                    <div class="row">

                                            <div class="col col-12">

                                                <az-input
                                                    label="Conteúdo do e-mail"
                                                    type="textarea"
                                                    :rows="6"
                                                    required
                                                    :validate="validate"
                                                    v-model="item.js_params.email_body_conteudo"
                                                />

                                            </div>

                                    </div>

                                    <div class="row" v-if="item.js_params.email_tipo_destinatario == 1">

                                            <div class="col col-12">

                                            <az-input
                                                    placeholder="Selecione o id da marcacao..."
                                                    label="Tags disponíveis"
                                                    sizing="sm"
                                                    icon="fa fa-plus"
                                                    type="select"
                                                    optionsDisplay="name"
                                                    optionsData="name"
                                                    :optionsList="lista_campos_email_destinatario"
                                                    v-model="email_body_tag"
                                                    @input="incluir_novo_campo()"
                                                />

                                            </div>

                                    </div>

                                    <div class="row" v-if="item.js_params.tipo == 7">

                                        <div class="col col-12">

                                        <az-input
                                                placeholder="Selecione a Tag..."
                                                label="Tags disponíveis"
                                                sizing="sm"
                                                icon="fa fa-plus"
                                                type="select"
                                                optionsDisplay="name"
                                                optionsData="name"
                                                :optionsList="lista_campos_email_fatura"
                                                v-model="email_body_tag"
                                                @input="incluir_novo_campo()"
                                            />

                                        </div>

                                        </div>
                                 

                                </template>

                            </div>

                            <!-- ANEXO -->
                            <div class="tab-pane fade show" v-if="item.js_params.tipo == 2 || item.js_params.tipo == 7" id="anexo" role="tabpanel" aria-labelledby="anexo-tab">
                                <div class="row">
                                    <div class="col col-6">
                                        <az-input
                                            placeholder="Selecionar relatório..."
                                            label="Relatório"
                                            type="select"
                                            optionsMode="aql"
                                            service="campanhas.relatorios"
                                            optionsDisplay="title"
                                            optionsData="id"
                                            v-model="item.js_params.email_anexo_relatorio_id"
                                        />
                                    </div>
                                </div>

                                <div class="row" v-if="item.js_params.email_anexo_relatorio_id">

                                    <div class="col col-6">
                                            <az-input
                                            type="select"
                                            placeholder="Selecione o tipo do anexo"
                                            label="Tipo do anexo"
                                            optionsDisplay="search"
                                            required
                                            :optionsList="[{id: '1', search: 'Corpo do e-mail'}, {id: '2', search: 'Em anexo'}]"
                                            optionsData="id"
                                            :validate="validate"
                                            v-model="item.js_params.email_anexo_tipo" />
                                    </div>

                                </div>

                                <div class="row" v-if="item.js_params.email_anexo_relatorio_id && item.js_params.tipo != 7">

                                    <div class="col col-6">
                                        <az-input
                                            placeholder="Selecione o período..."
                                            label="Parâmetro do relatório do tipo 'período'"
                                            type="select"
                                            optionsDisplay="title"
                                            optionsData="id"
                                            :optionsList="lista_parametros_email_anexo"
                                            v-model="item.js_params.email_anexo_relatorio_param"
                                        />
                                    </div>

                                </div>

                                <div  class="row" v-if="item.js_params.tipo == 7">
                                    <div class="col col-6">
                                        <az-input
                                            placeholder="Selecione o parâmetro..."
                                            label="Parâmetro do relatório (Id da Fatura)"
                                            type="select"
                                            optionsDisplay="title"
                                            optionsData="id"
                                            :optionsList="lista_parametros_email_anexo_extra"
                                            v-model="item.js_params.email_anexo_relatorio_param_extra"
                                        />
                                    </div>
                                </div>

                                <div class="row" v-if="item.js_params.email_anexo_relatorio_id && item.js_params.email_anexo_relatorio_param && item.js_params.tipo != 7">

                                    <div class="col col-4">
                                        <az-input
                                            placeholder="Informe o filtro do periodo..."
                                            label="Filtrar período"
                                            type="number"
                                            required
                                            :validate="validate"
                                            v-model="item.js_params.email_anexo_relatorio_param_dias"
                                        >
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                    <div class="input-group-append">
                                                        <az-input 
                                                            type="select"
                                                            class="ml-1"
                                                            :placeholder="Selecione"
                                                            optionsDisplay="search"
                                                            :optionsList="[
                                                                { id: 'hours', search: 'Hora(s)' },
                                                                { id: 'days', search: 'Dia(s)' },
                                                                { id: 'days_ate', search: 'Dia(s) até Hoje' },
                                                                { id: 'weeks', search: 'Semana(s)' },
                                                                { id: 'weeks_ate', search: 'Semana(s) até Hoje' },
                                                                { id: 'months', search: 'Mês(es)' }
                                                            ]"
                                                            optionsData="id"
                                                            :validate="validate"
                                                            v-model="item.js_params.tipo_antecedencia" />
                                                    </div>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>

                                    <div class="col col-2">
                                        <az-input
                                            type="select"
                                            placeholder="Selecione o tipo do filtro"
                                            label="Tipo do filtro do período"
                                            optionsDisplay="search"
                                            required
                                            :optionsList="[{id: '1', search: 'Anterior'}, {id: '2', search: 'Posterior'}]"
                                            optionsData="id"
                                            :validate="validate"
                                            v-model="item.js_params.email_anexo_relatorio_param_dias_ant"
                                        />
                                    </div>

                                </div>

                                <!-- Parametro extra -->
                                <div class="row" v-if="item.js_params.email_anexo_relatorio_id && item.js_params.email_tipo_destinatario == 1">

                                    <div class="col col-3">
                                        <az-input
                                            placeholder="Parâmetro extra..."
                                            label="Parâmetro extra do relatório"
                                            type="select"
                                            optionsDisplay="title"
                                            optionsData="id"
                                            :optionsList="lista_parametros_email_anexo_extra"
                                            v-model="item.js_params.email_anexo_relatorio_param_extra"
                                        />
                                    </div>

                                    <div class="col col-3">
                                        <az-input
                                            placeholder="Parâmetro extra..."
                                            label="Valor do parâmetro extra"
                                            type="select"
                                            optionsDisplay="title"
                                            optionsData="name"
                                            :optionsList="lista_campos_email_destinatario"
                                            v-model="item.js_params.email_anexo_relatorio_param_extra_valor"
                                        />
                                    </div>

                                </div>

                            </div>
                            
                             <!-- RESULTADOS -->
                            <div class="tab-pane fade show active" v-if="item.js_params.tipo == 6" id="resultados" role="tabpanel" aria-labelledby="resultados-tab">
                                <div class="row">
                                    <div class="col col-6">
                                        <az-input
                                            placeholder="Selecionar terceiro..."
                                            label="Selecione o Terceiro"
                                            type="select"
                                            optionsMode="aql"
                                            service="terceiros.lista"
                                            optionsDisplay="search"
                                            optionsData="id_terceiro"
                                            v-model="item.js_params.resultado_terceiro_id"
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                        <pre v-if="1==0">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <!-- <az-submit color="outline-secondary" @click="clonar()" v-if="item.id">
                            Clonar
                        </az-submit> -->
                        <az-audit-log-button model="Campanha" :id="item.id" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import VueCronEditorBuefy from 'vue-cron-editor-buefy';
import moment from "moment";
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';


export default {
    data () {
        return {
            dados: null,
            em_edicao: false,
            item: null,
            validate: false,
            search: "",
            viewMode: "A",
            title: "",
            short_title: "",
            service: "",
            relatorios: [],
            email_body_tag: null,
            whatsapp_body_tag: null,
            kualiz: false,
            escallo: false,
            ingenium: false,
            eas: false,
            envio_manual: null,
            filtros: {
                periodo: "h",
            },
            teste_mode_manual: false,
        }
    },

    props: ['cadastro'],

    components: {
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle,
        VueCronEditorBuefy,
        AzPeriodo,
        AzAuditLogButton, 
    },

    computed: {

        unidade_periodo: {
            get: function() {
                if (this.item.js_params && this.item.js_params.tipo_antecedencia) {
                    switch (this.item.js_params.tipo_antecedencia) {
                        case "hours": return 'Hora(s)';
                        case "days": return 'Dia(s)';
                        case "days_ate": return 'Dia(s) até Hoje';
                        case "weeks": return 'Semana(s)';
                        case "weeks_ate": return 'Semana(s) até Hoje';
                        case "months": return 'Mês(es)';
                    }

                    return 'Dia(s)';
                }

                if(!this.item || !this.item.st_cron) return 'Dia(s)';

                const cron = _.split(this.item.st_cron, ' ');
                if(Array.isArray(cron) && cron.length > 0) {
                    if(cron[4] != '*') {
                        return "Semana(s)";
                    } else if(cron[3] != '*') {
                        return "Mês(es)";
                    } else if(cron[2] != '*') {
                        return "Dia(s)";
                    } else if(cron[1] != '*') {
                        return "Hora(s)";
                    }
                }

                return 'Dia(s)';
            },
            set: function() {}
        },

        lista_filtros: function () {

            if ( !this.item )
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: function () {
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ?
                this.dados.filter (item => {
                    return ( this.viewMode == 'T' || item.fl_ativo ) &&
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        lista_campos_marcacao: function() {
            if(!this.item || !this.item.js_params.marcacao_relatorio_id) return [];

            let report = this.relatorios.find(item => item.id == this.item.js_params.marcacao_relatorio_id);

            return (report && report.config && report.config.columns) ? report.config.columns : [];
        },

        lista_parametros_marcacao: function() {
            if(!this.item || !this.item.js_params.marcacao_relatorio_id) return [];

            let report = this.relatorios.find(item => item.id == this.item.js_params.marcacao_relatorio_id);

            return (report && report.inputs) ? report.inputs.filter(item => item.type == 'per-date') : [];
        },

        lista_campos_email_destinatario: function() {
            if(!this.item || !this.item.js_params.email_destinatario_relatorio_id) return [];

            let report = this.relatorios.find(item => item.id == this.item.js_params.email_destinatario_relatorio_id);

            return (report && report.config && report.config.columns)
                ? _.map(report.config.columns,
                col => {
                    col.title = _.get(report.config.config_cols, col.name + '.title');
                    return col;
                })
                : [];
        },

        lista_campos_email_fatura: function() {
            if(!this.item) return [];

            return [
                { name: 'id_fatura' },
                { name: 'operadora_nome' },
                { name: 'operadora_contato'},
                { name: 'operadora_email'}
            ];
        },

        lista_campos_whatsapp_destinatario: function() {
            if(!this.item || !this.item.js_params.whatsapp_destinatario_relatorio_id) return [];

            let report = this.relatorios.find(item => item.id == this.item.js_params.whatsapp_destinatario_relatorio_id);

            return (report && report.config && report.config.columns)
                ? _.map(report.config.columns,
                col => {
                    col.title = _.get(report.config.config_cols, col.name + '.title');
                    return col;
                })
                : [];
        },

        lista_parametros_email_destinatario: function() {
            if(!this.item || !this.item.js_params.email_destinatario_relatorio_id) return [];

            let report = this.relatorios.find(item => item.id == this.item.js_params.email_destinatario_relatorio_id);

            return (report && report.inputs) ? report.inputs.filter(item => item.type == 'per-date') : [];
        },

        lista_parametros_whatsapp_destinatario: function() {
            if(!this.item || !this.item.js_params.whatsapp_destinatario_relatorio_id) return [];

            let report = this.relatorios.find(item => item.id == this.item.js_params.whatsapp_destinatario_relatorio_id);

            return (report && report.inputs) ? report.inputs.filter(item => item.type == 'per-date') : [];
        },

        lista_parametros_email_anexo: function() {
            if(!this.item || !this.item.js_params.email_anexo_relatorio_id) return [];

            let report = this.relatorios.find(item => item.id == this.item.js_params.email_anexo_relatorio_id);

            return (report && report.inputs) ? report.inputs.filter(item => item.type == 'per-date') : [];
        },

        lista_parametros_email_anexo_extra: function() {
            if(!this.item || !this.item.js_params.email_anexo_relatorio_id) return [];

            let report = this.relatorios.find(item => item.id == this.item.js_params.email_anexo_relatorio_id);

            return (report && report.inputs) ? report.inputs.filter(item => item.type != 'per-date') : [];
        },

        lista_parametros_activecampaign: function() {
            if(!this.item || !this.item.js_params.activecampaign_relatorio_id) return [];

            let report = this.relatorios.find(item => item.id == this.item.js_params.activecampaign_relatorio_id);

            return (report && report.inputs) ? report.inputs.filter(item => item.type == 'per-date') : [];
        },

        is_campanha_manual: function() {
            return (
                this.item &&
                this.item.js_params &&
                (this.item.js_params.tipo == "2" ||
                    this.item.js_params.tipo == "5") &&
                this.item.fl_manual
            );
        },

    },

    methods: {
        exibir_periodo() {
            let antecedencia = 0;
            let anteriorPosterior = 1;

            if (this.item && this.item.js_params) {
                if (this.item.js_params.tipo == "5") {
                    // Mensagem por whats app
                    antecedencia = this.item.js_params.whatsapp_destinatario_relatorio_param_dias;
                    anteriorPosterior = this.item.js_params.whatsapp_destinatario_relatorio_param_dias_ant == 1 ? -1 : 1;
                } else if(this.item.js_params.tipo == "2") {
                    // Mensagem por email
                    antecedencia = this.item.js_params.email_destinatario_relatorio_param_dias
                    anteriorPosterior = this.item.js_params.email_destinatario_relatorio_param_dias_ant == 1 ? -1 : 1;
                } else if(this.item.js_params.tipo == "3") {
                    // Mensagem por activecampaign
                    antecedencia = this.item.js_params.activecampaign_relatorio_param_dias
                    anteriorPosterior = this.item.js_params.activecampaign_relatorio_param_dias_ant == 1 ? -1 : 1;
                }
            }

            if (this.item.js_params && this.item.js_params.tipo_antecedencia) {
                let dataInicial, dataFinal = null;
                let diaDaSemana = 0;
                let diasParaAdicionar = 0;
                let date = null; 

                switch (this.item.js_params.tipo_antecedencia) {
                    case "hours": return "";

                    case "days":
                        dataInicial = this.$util.getDataDias(antecedencia * anteriorPosterior, "DD/MM/YYYY") + " 00:00:00";
                        dataFinal = this.$util.getDataDias(antecedencia * anteriorPosterior, "DD/MM/YYYY") + " 23:59:59";
                        break;

                    case "days_ate":
                        if(anteriorPosterior == 1) {
                            dataInicial = this.$util.getDataDias(+1, "DD/MM/YYYY") + " 00:00:00";
                            dataFinal = this.$util.getDataDias(antecedencia * anteriorPosterior, "DD/MM/YYYY") + " 23:59:59";
                        } else {
                            dataInicial = this.$util.getDataDias(antecedencia * anteriorPosterior, "DD/MM/YYYY") + " 00:00:00";
                            dataFinal = this.$util.getDataDias(-1, "DD/MM/YYYY") + " 23:59:59";
                        }
                        break;

                    case "weeks":
                        diaDaSemana = new Date().getDay(); 
                        diasParaAdicionar = diaDaSemana - ((7 * antecedencia) * anteriorPosterior); 

                        dataInicial = this.$util.getDataDias(-diasParaAdicionar, "DD/MM/YYYY") + " 00:00:00";
                        dataFinal = this.$util.getDataDias(-diasParaAdicionar + 6, "DD/MM/YYYY") + " 23:59:59";

                        break;

                    case "weeks_ate":
                        if (anteriorPosterior == 1) {
                            dataInicial = this.$util.getDataDias(+1, "DD/MM/YYYY") + " 00:00:00";
                            dataFinal = this.$util.getDataDias(antecedencia * 7 * anteriorPosterior, "DD/MM/YYYY") + " 23:59:59";
                        } else {
                            dataInicial = this.$util.getDataDias(antecedencia * 7 * anteriorPosterior, "DD/MM/YYYY") + " 00:00:00";
                            dataFinal = this.$util.getDataDias(-1, "DD/MM/YYYY") + " 23:59:59";
                        }
                        break;

                    case "months":
                        if (anteriorPosterior == 1) {
                            date = moment().add(antecedencia, 'months');
                            dataInicial = date.startOf('month').format('DD/MM/YYYY') + " 00:00:00";
                            dataFinal = date.endOf('month').format('DD/MM/YYYY') + " 23:59:59";
                        } else {
                            date = moment().add(-antecedencia, 'months');
                            dataInicial = date.startOf('month').format('DD/MM/YYYY') + " 00:00:00";
                            dataFinal = date.endOf('month').format('DD/MM/YYYY') + " 23:59:59";
                        }
                        break;
                }

                return "Ex.: Hoje, buscar para o período de " + dataInicial + " até " + dataFinal;
            }


            return "";
        },

        filtrar_periodo_label() {
            const label = "Filtrar período/Atecedência";
            if(this.item && this.item.js_params && this.item.js_params.tipo_antecedencia) {
                return label;
            }

            return label + ": " + this.unidade_periodo;
        },

        abrir_relatorio (id) { 
            $('.modal').modal('hide');
            
            this.$router.push({ name: 'relatorio', params: { id: id, backlink: this.$route.path } });
        },

        confirmar_envio_manual() {
            this.$util.atualizar(this, {
                service: 'campanhas',
                func: 'executar_agora',
                modal: 'envioManualModal',
                dados: {
                    id: this.envio_manual.id,
                    periodo_manual: this.filtros,
                    teste_mode: this.teste_mode_manual,
                },
                toast: true,
                msg: 'Execução realizada.',
            });
        },

        executar_agora (camp, teste = false) {
            this.teste_mode_manual = teste;
            if(camp.fl_manual) {
                this.envio_manual = camp;
                $('#envioManualModal').modal('show');
                return;
            }

            if ( !confirm ('Confirma disparar a execução agora?') )
                return;

            this.$util.atualizar(this, {
                service: 'campanhas',
                func: 'executar_agora',
                dados: {
                    id: camp.id,
                    teste_mode: teste,
                },
                toast: true,
                msg: 'Execução realizada.',
            });
        },

        loadRelatorios() {
            this.$util.loadItem(this, {
                service: 'campanhas',
                func: 'relatorios',
            })
            .then(res => {
                this.relatorios = res;
            });
        },

        incluir_novo_campo() {
            if ( !this.email_body_tag )
                return;

            this.item.js_params.email_body_conteudo = this.item.js_params.email_body_conteudo + ' #' + this.email_body_tag;

            this.email_body_tag = null;

            this.$nextTick(() => {
                this.email_body_tag = "";
            });
        },

        incluir_novo_campo_whatsapp() {
            if ( !this.whatsapp_body_tag )
                return;

            this.item.js_params.whatsapp_body_conteudo = this.item.js_params.whatsapp_body_conteudo + ' #' + this.whatsapp_body_tag;

            this.whatsapp_body_tag = null;

            this.$nextTick(() => {
                this.whatsapp_body_tag = "";
            });
        },

        incluir () {
            this.validate = false;

            let item = {
                st_cron: "0 0 */1 * *",
                js_params: {
                    tipo: 1, // Tipo da campaanha (confirmar marcação)
                    marcacao_tipo_destinatario: 1,
                    email_tipo_destinatario: 2,
                    email_tipo_conteudo: 2,
                    email_anexo_tipo: 1,
                    email_anexo_relatorio_param_dias_ant: 1,
                    email_destinatario_relatorio_param_dias_ant: 1,
                    whatsapp_tipo_destinatario: 1,
                },

            };

            this.editar (item);
        },
        load () {
            this.$util.load(this, {
                service:'campanhas',
                func: 'index',
                parms: {
                    cadastro: true,
                },
                final: () => {
                    this.loadRelatorios();
                }
            });

        },
        editar (item) {
            this.validate = false;
            this.item = _.cloneDeep (item);

            if ( !this.item.st_cron ) {
                this.item.st_cron = "0 0 */1 * *";
            }

            if ( !this.item.js_params.marcacao_tipo_destinatario ) {
                this.item.js_params.marcacao_tipo_destinatario =  1 ;
            }
            if ( !this.item.js_params.email_anexo_relatorio_param_dias_ant ) {
                this.item.js_params.email_anexo_relatorio_param_dias_ant =  1 ;
            }

            if ( !this.item.js_params.email_destinatario_relatorio_param_dias_ant ) {
                this.item.js_params.email_destinatario_relatorio_param_dias_ant =  1 ;
            }

            $('#edicaoModal').modal('show');
        },
        atualizar () {
            this.$util.atualizar(this, {
                service: 'campanhas',
                dados: this.item,
                reload: true,
                modal: 'edicaoModal',
            });
        },

        fechar () {
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },

        toggle (item) {

            this.$util.toggle(this, {
                service: 'campanhas',
                dados: item,
            });

        },

        format (n) {
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () {

        this.$util.load(this, {
            service:'mensagens_tipo',
            func: 'index',
            parms: {
                cadastro: true,
            },
            loadTo: res => { 
                if ( !res ) {
                    this.kualiz = false;
                    this.escallo = false;
                    this.ingenium = false;
                    this.eas = false;
                }

                const item = _.first(res);
                const servico = item && item.servico_whatsapp ? item.servico_whatsapp : '';
                console.log('servico', servico);

                this.kualiz = item && (
                    servico.toUpperCase() == 'Qualizap'.toUpperCase() ||
                    servico.toUpperCase() == 'Kualiz'.toUpperCase()
                );

                this.escallo = item && (
                    servico.toUpperCase() == 'Escallo'.toUpperCase()
                );

                this.ingenium = item && (
                    servico.toUpperCase() == 'ingenium'.toUpperCase()
                );

                this.eas = item && (
                    servico.toUpperCase() == 'eas'.toUpperCase()
                );
            }
        });

        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Envio de Mensagem Programado", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () {
        $('[data-toggle="tooltip"]').tooltip();
    }

}
</script>